import { useSyncExternalStore } from 'react';

import { getPageTitle, setPageTitle, subscribePageTitle } from '../services/layout/page-title.store';

export function usePageTitle() {
    return useSyncExternalStore(subscribePageTitle, getPageTitle, getPageTitle);
}

export { setPageTitle };
